import { render, staticRenderFns } from "./BotaoScroll.vue?vue&type=template&id=6f13af84&"
import script from "./BotaoScroll.vue?vue&type=script&lang=js&"
export * from "./BotaoScroll.vue?vue&type=script&lang=js&"
import style0 from "./BotaoScroll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports